/**
 * Tarayıcı otomatik doldurma / kayıtlı adres önerilerini mümkün olduğunca kesmek için.
 * Chrome bazen autoComplete="off"u yok sayar; ek data-* ile şifre yöneticileri de susturulur.
 */
export const autofillOffProps = {
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: false,
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-bwignore": "true",
    "data-form-type": "other",
};

/**
 * E-posta biçimli alanlarda Chrome öneri menüsünü daha sık engeller (OTP alanı gibi işlenir).
 */
export const autofillOffEmailLikeProps = {
    ...autofillOffProps,
    autoComplete: "one-time-code",
};

/** select için (spellCheck vb. geçerli değil) */
export const autofillOffSelectProps = {
    autoComplete: "off",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-bwignore": "true",
    "data-form-type": "other",
};
